import t from "./td-longtail-vue-components133.js";
/* empty css                              */
import l from "./td-longtail-vue-components98.js";
var s = function() {
  var r = this, i = r._self._c, e = r._self._setupProxy;
  return i(e.InputWrapper, { staticClass: "radio-group", attrs: { id: `${e.inputId}-radio-group`, "error-message": r.errorMessage, required: r.required, disabled: r.disabled, "aria-invalid": !!r.errorMessage, role: "radiogroup", "aria-describedby": `${e.inputId}-radio-group-error`, medium: !1, large: !1, "inline-label": !1 } }, [i("div", { staticClass: "radio-group__container", class: {
    "radio-group__container--vertical-xs": r.verticalXs,
    "radio-group__container--vertical-sm": r.verticalSm,
    "radio-group__container--vertical-md": r.verticalMd,
    "radio-group__container--vertical-lg": r.verticalLg
  } }, r._l(r.options, function(a, o) {
    return i(e.RadioInput, { key: o, attrs: { value: e.inputValue, name: r.name, label: `${r.name}-${a.value}`, val: a.value }, on: { input: function(n) {
      return r.$emit("input", n);
    } } }, [r._t("default", function() {
      return [i("span", { domProps: { innerHTML: r._s(a.label) } })];
    }, { selected: a.value === e.inputValue, item: a })], 2);
  }), 1)]);
}, u = [], d = /* @__PURE__ */ l(
  t,
  s,
  u,
  !1,
  null,
  "4ea45a55"
);
const m = d.exports;
export {
  m as default
};
